export default {
	name: "SquareArrowButton",
	props: {
		type: { type: String, required: true },
		contentType: { type: String, default: "" },
		contentTypeId: { type: Number, default: 0 },
		title: { type: String, required: true },
	},
	data() {
		return {
			isTextTruncated: false,
		};
	},
	computed: {
		borderAndArrowColor() {
			if (this.type === "solution") return "#3366FF";
			if (this.type === "content") {
				switch (this.contentTypeId) {
					case 1:
						return "#E3551F";
					case 2:
						return "#760698";
					case 3:
						return "#0E0698";
					case 4:
						return "#069817";
					default:
						return "#3366FF";
				}
			}
			return "#3366FF";
		},
		borderClass() {
			return {
				border: true,
				"border-blue": this.type === "solution",
				"border-[#E3551F]":
					this.type === "content" && this.contentTypeId === 1,
				"border-[#760698]":
					this.type === "content" && this.contentTypeId === 2,
				"border-[#0E0698]":
					this.type === "content" && this.contentTypeId === 3,
				"border-[#069817]":
					this.type === "content" && this.contentTypeId === 4,
			};
		},
	},
	methods: {
		checkTextTruncation() {
			this.$nextTick(() => {
				const titleElement = this.$refs.titleRef;
				if (titleElement) {
					this.isTextTruncated = titleElement.scrollHeight > titleElement.clientHeight;
				}
			});
		},
	},
	mounted() {
		this.checkTextTruncation();
	},
	updated() {
		this.checkTextTruncation();
	},
};

